<div class="container fx-layout-row-wrap">

  <div class="toolbar-container fx-flex-100">
    <gp-toolbar *ngIf="!isLogin()"></gp-toolbar>
  </div>

  <div class="outlet-container fx-flex-100">
    <router-outlet></router-outlet>
  </div>

</div>
